import { Component,  Input, EventEmitter, Output, OnInit, TemplateRef } from '@angular/core';
import publicHelpers from 'src/app/helpers/public-helpers';
import { LabelMaps } from 'src/app/store/events.era';
import { Performer } from 'globals/store/performers.data';
import { makeProgramText } from 'globals/helpers/helpers';
import { OnsiteSingleTimeline, OnsiteTimelineBrick } from 'globals/store/onsite.data';
import { Sponsor  } from 'globals/store/sponsors.data';
import { Ranking, Venue } from 'globals/store/events.data';
import { Dictionary } from '@ngrx/entity';
import { TagPanelData } from 'globals/store/tags.data';
import { TimelineItemComponent } from 'src/app/components/timeline/timeline-item.component';
import { CommonModule } from '@angular/common';
import { TimelineStartPipe } from 'src/app/services/pipes/timelineStart.pipe';
@Component({
    selector: 'single-timeline',
    templateUrl: './onsite.singletimeline.html',
    styleUrls: ['./onsite.singletimeline.scss'],
    standalone: true,
    imports: [TimelineItemComponent, CommonModule, TimelineStartPipe],
})

export class OnsiteSingleTimelineComponent implements OnInit {
  @Input() singleTimeline: OnsiteSingleTimeline
  @Input() performers: { [pId: string]: Performer }
  @Input() sponsors: { [key: string]: Sponsor }
  @Input() sponsorIds: string[]
  @Input() sponsorTypes: { [tId:string]: Ranking }
  @Input() performer: Performer
  @Input() detailedMode = true
  @Input() brief = false
  @Input() condensedPerformers = true
  @Input() showActivityStatus = true
  @Input() labelMaps: LabelMaps
  @Input() publicView = false
  @Input() link = true
  @Input() hidePerformersHeading = false
  @Input() collapseByDefault = false
  @Input() venues: { [id:string]: Venue }
  @Input() tagMap: Dictionary<TagPanelData> = {}
  @Input() performerRoles: Dictionary<Ranking>

  @Output() emitBrickDetail: EventEmitter<any> = new EventEmitter()
  @Output() openProgramEmitter: EventEmitter<any> = new EventEmitter()
  programLines = {}  
  publicHelpers = publicHelpers
  ngOnInit() {
    // console.log({ singleTimeline: this.singleTimeline, this: this })
  }

  ngOnChanges(changes) {
    if (changes && changes.singleTimeline && changes.singleTimeline.currentValue) {
      this.programLines = {}
      // console.log({ singleTimeline: changes.singleTimeline.currentValue })
       changes.singleTimeline.currentValue.bricks.forEach(({ program_title, program_location, venueId, id, hideVenueAddress, hideVenueName }: OnsiteTimelineBrick ) => 
        this.programLines[id] = makeProgramText(program_title, program_location, !this.venues ? {} : this.venues[venueId] || {}, hideVenueAddress, hideVenueName)
      )
    }
  }

  trackByBrick(index, brick: OnsiteTimelineBrick) {
    return brick.id
  }
}

